import UserInformationTable from "./UserInformationTable";
import { useContext, useState } from "react";
import { MyContext } from "../context/myContext";
import DatePickerComponent from "./DatePickerComponent";
import { EnglishToPersian } from "numeral-convert";
import { useDispatch, useSelector } from "react-redux";
import {
  getExcel,
  // getNomadHistory,
  selectShowHistory,
} from "../features/common-states/commonStatesSlice";


const HistoryPopUp = ({ nomad ,excelData,persianDate,setPersianDate}) => {
  const dispatch = useDispatch();
  // const storeDispatch = useDispatch();

  const { title, handleShowHistory } = useContext(MyContext);
  // const records = searchedBodyArray?.length > 0 ? searchedBodyArray : bodyArray;

  const [isLoading, setIsLoading] = useState(false); // <-- loading state
  const showHistory = useSelector(selectShowHistory);
  
  const handleStartDateChange = (timestamp, newDate) => {
    console.log(newDate);
    let persianNumbers = EnglishToPersian(newDate);
    setPersianDate({ ...persianDate, startDate: persianNumbers });
  };
  const handleEndDateChange = (timestamp, newDate) => {
    console.log(newDate);
    let persianNumbers = EnglishToPersian(newDate);
    setPersianDate({ ...persianDate, endDate: persianNumbers });
  };
  

  

  
  const handleGetExcel = async (cityId) => {  // <-- make async
    // Check dates
    if (!persianDate.startDate || !persianDate.endDate) {
      alert("لطفاً بازه تاریخ را انتخاب کنید");
      return;
    }



    setIsLoading(true);  // <-- show loading
    try {
      await dispatch(getExcel(excelData)).unwrap(); // unwrap to catch rejection
      console.log("excel data:", excelData);
    } catch (error) {
      console.error("Excel download failed:", error);
      alert("خطا در دریافت فایل اکسل");
    } finally {
      setIsLoading(false); // <-- hide loading
    }
  };

  // const handleChangePage = (item) => {
  //   storeDispatch(getNomadHistory({ nomad_id: nomad.id, page: item }));
  // };
  
  return (
    <div
      className={`${showHistory && "top-[20px]"} popup-styles !px-3 sm:!px-5 w-[95vw]`}
    >
      <div className="flex flex-wrap justify-between items-center gap-x-4 gap-y-2 py-2">
      
          <div className="flex items-center gap-1 [&_input]:!w-[120px] sm:[&_input]:!w-[150px]">
            <i
              className="fa fa-times close-icon"
              onClick={handleShowHistory}
            ></i>
            <button
              onClick={handleGetExcel}
              className="py-2 px-1 text-white text-xs bg-green-500 border-none rounded-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading}  // <-- disable while loading
            >
              {isLoading ? (
                <>
                  <i className="fa fa-spinner fa-spin ml-1"></i>
                  در حال ساخت...
                </>
              ) : (
                "اکسل"
              )}
            </button>
            <DatePickerComponent
              preSelected={persianDate.endDate.toString()}
              handleChange={handleEndDateChange}
              label=":تا"
            />
            <DatePickerComponent
              preSelected={persianDate.startDate.toString()}
              handleChange={handleStartDateChange}
              label=":از"
            />
          </div>

        <div className="text-sm ml-auto border-b border-b-2 py-2">
          <p>{title}</p>
        </div>
      </div>
      <UserInformationTable />
      {/* <Pagination handleChangePage={handleChangePage} /> */}
      <div className="py-3">
        <button
          className="button-styles bg-red-500 hover:bg-red-600 text-xs sm:text-sm"
          onClick={handleShowHistory}
        >
          بستن
        </button>
      </div>
    </div>
  );
};

export default HistoryPopUp;